import {
  Heading,
  Container,
  Button, Text, Grid,
  GridItem, Flex,
  Icon
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import HomepageCard from "./homepageCard/HomepageCard";
import { FaBuildingColumns, FaHandshakeAngle, FaRegNewspaper } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { useEffect } from "react";

export default function Homepage() {

  const navigate = useNavigate();
  const isUserAuthenticated = useSelector(
    (state: any) => state.user?.isAuthenticated
  )

  useEffect(() => {
    if (isUserAuthenticated) {
      navigate("/dashboard")
    }
  })

  return (
    <>
      <section className="homepageMainSection">
        <Container maxW="container.xl" pt={5}>
          <Grid
            h="30vh"
            templateRows="repeat(1, 1fr)"
            templateColumns="repeat(2, 1fr)"
            gap={4}
          >
            <GridItem rowSpan={1} colSpan={1} className="homePageMainContent">
              <Heading as="h1" size="2xl" mb={5}>
                TM - TERZA MISSIONE
              </Heading>
              <Text fontSize="xl">
                Gestionale per l'inserimento, la visualizzazione ed il
                monitoraggio dei parametri relativi alla Terza Missione
                dell'Università degli Studi di Padova.
              </Text>
              <Link to={"/login"}>
                <Button mt={5} variant={"solid"}>
                  Accedi tramite SSO
                </Button>
              </Link>
            </GridItem>
            <GridItem className="homepageImage" colSpan={1} />
          </Grid>
        </Container>
      </section>
      <section className="homepageSecondSection">
        <Container maxW={"container.xl"} mt={12} mb={12}>
          <Flex flexWrap="wrap" gridGap={6} justify="space-between">
            <HomepageCard
              heading={"Terza Missione"}
              icon={<Icon as={FaBuildingColumns} w={10} h={10} />}
              description={
                "Scopri come l'Università di Padova si impegna nella Terza Missione."
              }
              href={"https://www.unipd.it/terza-missione#"}
            />
            <HomepageCard
              heading={"News"}
              icon={<Icon as={FaRegNewspaper} w={10} h={10} />}
              description={
                "Scopri le novità relative alla Terza Missione."
              }
              href={"https://www.unipd.it/news/terza-missione"}
            />
            <HomepageCard
              heading={"Progetti"}
              icon={<Icon as={FaHandshakeAngle} w={10} h={10} />}
              description={
                "Progetti e opportunità della Terza Missione."
              }
              href={"https://www.unipd.it/progetti-terza-missione"}
            />
          </Flex>
        </Container>
      </section>
    </>
  );
}
